/**
 * Created by jonas on 2020-09-17.
 */


import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Outsourced} from "../Outsourced";

import {gsap} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {WinWays} from "../components/WinWays";
import {BasedCountUp} from "../components/BasedCountUp";
import {OutsourcedGameAssets} from "../OutsourcedGameAssets";
import {WinConfigUtilBased} from "../utils/WinConfigUtil";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {reelPosition} from "../server/OutsourcedModel";
import {OutsourcedStatics} from "../config/OutsourcedStatics";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";


// a step in the right direction but definetly not perfect, rewrite for next game
export class OutsourcedWinView extends PIXI.Container implements StageLayer {
    private basedCountUp:BasedCountUp;
    //private basedWinWays:WinWays;
    private bigWinAnimation:PIXI.spine.Spine;
    private blackOut:PIXI.Sprite;
    private isBigWin:boolean;
    tints:number[];

    constructor() {
        super();
        this.name = "OutsourcedWinView";

        this.tints = [
            PIXI.utils.string2hex("#0000CC"),
            PIXI.utils.string2hex("#0000CC"),
            PIXI.utils.string2hex("#0000CC"),
            PIXI.utils.string2hex("#FF0033"),
            PIXI.utils.string2hex("#9900FF"),
        ]

        this.blackOut = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.blackOut.name = "blackOut";
        this.blackOut.tint = PIXI.utils.string2hex("#0000CC");
        this.blackOut.position.set(360,360);
        this.blackOut.anchor.set(0.5,0.5);
        this.blackOut.alpha = 0;

        this.bigWinAnimation = new PIXI.spine.Spine(Outsourced.assetLoader.getSpineAsset(OutsourcedGameAssets.BIG_WIN_SPINE));
        this.bigWinAnimation.position.set(360, 360);

        this.basedCountUp = new BasedCountUp();
        this.basedCountUp.position.set(360, 250);
        //this.basedWinWays = new WinWays();
        //this.basedWinWays.position.set(360, 420);

        this.addChild(this.blackOut);
        this.addChild(this.bigWinAnimation);
        this.addChild(this.basedCountUp);
        //this.addChild(this.basedWinWays);

        this.onResize();
    }

    // why is there no branch for when its not a big win
    private moveWinCountup() {
        if (this.isBigWin) {
            if (NolimitApplication.isLandscape) {
                this.basedCountUp.position.set(360, 520);
                //this.basedWinWays.position.set(360, 690);
            } else {
                this.basedCountUp.position.set(360, 650);
                //this.basedWinWays.position.set(360, 820);
            }
        }
    }

    public onResize() {
        this.blackOut.width = NolimitApplication.screenBounds.width;
        this.blackOut.height = NolimitApplication.screenBounds.height;
        this.moveWinCountup();
    }

    //public winToggle(win:number, ways:number): gsap.core.Timeline {
    //   return gsap.timeline()
    //       .add(() => {
    //           this.basedCountUp.position.set(360, 250);
    //           this.basedWinWays.position.set(360, 380);
    //       })
    //       .add(this.basedCountUp.countUpInstant(win, 0))
    //       .add(this.basedWinWays.show(ways), '<')
    //       .add(this.basedCountUp.hide(), '>1')
    //       .add(this.basedWinWays.hide(), '<');
    //}

    public clear(): gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.basedCountUp.position.set(360, 250);
                //this.basedWinWays.position.set(360, 420);
                this.basedCountUp.hide();
                //this.basedWinWays.hide();
            })
    }

    public showAfterMaxWin(win:number):gsap.core.Timeline {
       return gsap.timeline().add(this.basedCountUp.showNoFade(win));
    }

    public showIndividualWin(amount:number, waysCount:number, reel:number, row:number):gsap.core.Timeline {
        const startX = (reel + 0.5) * 180;
        const startY = (row + 0.5) * 148 + 90;

        const winText = new PIXI.BitmapText(`${SlotGame.apiPlugin.currency.formatValue(amount)}`, {
            fontName: OutsourcedGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 60,
        });
        winText.position.set(0, -80);
        winText.anchor = 0.5;


        const wayOrWays = waysCount > 1 ? "ways" : "way"
        const ways = new PIXI.Text(`${waysCount} ${Outsourced.apiPlugin.translations.translate(wayOrWays)}`, {
            fill: "#00FF66",
            fontFamily: "Helvetica",
            fontSize: 60,
            fontStyle: "oblique",
            fontWeight: "bolder",
            lineJoin: "round",
            strokeThickness: 8
        })
        ways.anchor.set(0.5, 0.5);
        ways.position.set(0, 90);

        const textContainer = new PIXI.Container();
        textContainer.addChild(winText);
        textContainer.addChild(ways);
        textContainer.position.set(startX, startY);
        const textScale = 180 / textContainer.width;
        textContainer.scale.set(textScale, textScale);

        return gsap.timeline()
            .add(() => {
                this.addChild(textContainer)
            })
            .add(gsap.to(textContainer.position, {y: startY - 50, duration: 0.4}))
            .add(gsap.to(textContainer, {alpha: 0, duration: 0.1}), '<0.3')
            .add(() => {
                textContainer.removeChild(winText);
                textContainer.removeChild(ways);
                winText.destroy();
                ways.destroy();
                this.removeChild(textContainer);
                textContainer.destroy();
            })
    }


    public countUpWin(to:number, from:number = 0, duration = 1, ways = Outsourced.model.totalWays):gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.basedCountUp.position.set(360, 250);
                //this.basedWinWays.position.set(360, 420);
            })
            .add(duration > 0
                 ? this.basedCountUp.countUp(to, from, duration)
                 : this.basedCountUp.countUpInstant(to, from))
            //.add(this.basedWinWays.show(ways))
            .add(this.basedCountUp.hide(), '>0.6')
            //.add(this.basedWinWays.hide(), '<');
    }

   public bigWinStart(to:number, from:number, level:number):gsap.core.Timeline  {
       return gsap.timeline()
           .add(() => {
               this.isBigWin = true;
               this.moveWinCountup();
               this.blackOut.tint = this.tints[level - 1];
           })
           .add(gsap.to(this.blackOut, {alpha: 0.8, duration:0.1}), '<')
           .add(gsap.to(this.bigWinAnimation, {alpha: 1, duration:0.1}), '<')
           .add(SpineGSAPWrapper.createTimeline(this.bigWinAnimation, 0, "BW_1_Intro"), '<')
           .add(() => {
               this.bigWinAnimation.state.setAnimation(0, `BW_${level}_Loop`, true);
           })
           .add(this.basedCountUp.countUp(to, from, WinConfigUtilBased.bigLevels[level - 1].duration), '<')
   }

    public bigWinMiddle(to:number, from:number, level:number):gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.blackOut.tint = this.tints[level - 1];
                this.bigWinAnimation.state.setAnimation(0, `BW_${level}_Loop`, true);
            })
            .add(this.basedCountUp.countUpNoFade(to, from, WinConfigUtilBased.bigLevels[level - 1].duration))
    }

    public bigWinEnd(level:number):gsap.core.Timeline {
        return gsap.timeline()
            .add(gsap.to(this.basedCountUp.position, {y: 250, duration: 0.7}))
            //.add(gsap.to(this.basedWinWays.position, {y: 420, duration: 0.7}), '<')
            //.add(this.basedWinWays.show(Outsourced.model.totalWays))
            .add(this.basedCountUp.hide(), '>1.2')
            //.add(this.basedWinWays.hide(), '<')
            //.add(SpineGSAPWrapper.createTimeline(this.bigWinAnimation, 0, `BW_${level}_End`))
            .add(gsap.to(this.bigWinAnimation, {alpha: 0, duration:0.1}))
            .add(gsap.to(this.blackOut, {alpha: 0, duration:0.1}), '<')
            .add(() => {
                this.bigWinAnimation.state.setEmptyAnimation(0, 0)
                this.isBigWin = false;
            });
    }
}